import {useEffect, useState} from "react";
import MainLayout from "../layouts/MainLayout/MainLayout";
import Button from "../components/MD/Button";
import axios from "axios";
import * as rdd from 'react-device-detect';
import {useParams} from "react-router-dom";
import {v4 as uuidv4, validate} from "uuid";
import { 
    Box, 
    Typography, 
    Container, 
    Paper, 
    Divider,
    List,
    ListItem,
    ListItemText,
    Grid
} from "@mui/material";

const FantalabManagerRulesPage = () => {

    return (
        <MainLayout
            //bgColor={R.palette.white.main}
            //bgColor2={R.palette.dark.focus}
            horizontalPadding={0}
            emptyLayout
            verticalPadding={0}
            backgroundColorOverlay={0.75}
        > 
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                    <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 3 }}>
                        Name of the promotion "Fantalab Manager"
                    </Typography>
                    
                    <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 2 }}>
                        FULL TERMS AND CONDITIONS
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        FANTALAB LTD, UK, Flat 202 Marden House 4 Batty Street, London, England, E1 1RH, VAT: 446483177 
                        ((hereinafter the Promoter) is organizing this promotion called "Fantalab Manager".
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        The Promotion is open to all consumers (hereinafter also referred to as "users") who are of legal age, 
                        have an Internet connection, become aware of the initiative, and are either already subscribed to the 
                        Fantalab Premium service or subscribe to it during the Contest period. Employees of the Promoter, and 
                        their immediate families, their agents or anyone professionally connected to this Promotion shall not be 
                        entitled to enter.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        Furthermore, the promotion is not open to residents of countries where federal, state, provincial, 
                        municipal, or local laws or regulations prohibit participation in skill-based contests.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        Participation in this Promotion is free of charge
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        Any person entering into or participating in this Promotion is deemed to have accepted and to be bound 
                        by these terms and conditions.
                    </Typography>
                </Paper>

                <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                    <Typography variant="h5" component="h3" gutterBottom sx={{ mb: 2 }}>
                        1. Promotional period
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        The promotion is open from 12pm on 01/08/2025 to 11:59 pm on 12/05/2026(GMT +1).
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        The promotional period is divided into weeks corresponding to the matchdays of the Serie A football 
                        calendar, available at the following link: https://www.legaseriea.it/it/serie-a.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        It is specified that the match schedule may be subject to changes beyond the control of the promoting 
                        company. Any changes will be duly communicated to participants via the contest website/app.
                    </Typography>
                </Paper>

                <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                    <Typography variant="h5" component="h3" gutterBottom sx={{ mb: 2 }}>
                        2. Entry and participation
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        To participate, eligible individuals must:
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText 
                                primary="Visit the website https://www.Fantalab.it/ or download the app from https://play.google.com/store/apps/details?id=com.Fantalab.app, and either log in to their account or, in the case of first-time access, complete the registration process;"
                            />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText 
                                primary="After entering the &quot;Fantalab Manager&quot; section, users will be able to select the players who will form their team."
                            />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph>
                        Once these steps have been completed, contest participants will gain access to the "Rooms" section — 
                        corresponding to the gameplay periods, which will be described in detail below — and begin accumulating 
                        points to climb the leaderboard.
                    </Typography>
                    
                    <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
                        There are three types of Rooms:
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText 
                                primary="YEARLY ROOM: from matchday No. 3 until matchday No. 36"
                            />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText 
                                primary="3-WEEKLY ROOMS: These are three-week (3) blocks that span the entire football season and are divided as follows:"
                            />
                        </ListItem>
                    </List>
                    
                    <Box sx={{ pl: 6, mb: 2 }}>
                        <Typography variant="body2" component="div">
                            Block 1: from matchday No. 1 until matchday No. 3<br/>
                            Block 2: from matchday No. 4 until matchday No. 6<br/>
                            Block 3: from matchday No. 7 until matchday No. 9<br/>
                            Block 4: from matchday No. 10 until matchday No. 12<br/>
                            Block 5: from matchday No. 13 until matchday No. 15<br/>
                            Block 6: from matchday No. 16 until matchday No. 18<br/>
                            Block 7: from matchday No. 19 until matchday No. 21<br/>
                            Block 8: from matchday No. 22 until matchday No. 24<br/>
                            Block 9: from matchday No. 25 until matchday No. 27<br/>
                            Block 10: from matchday No. 28 until matchday No. 30<br/>
                            Block 11: from matchday No. 31 until matchday No. 33<br/>
                            Block 12: from matchday No. 34 until matchday No. 36
                        </Typography>
                    </Box>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText 
                                primary="CREATOR ROOM: From matchday 3 to matchday 26 only, users will have the option to join a &quot;Creator Room,&quot; associated with a specific creator and allowing them to earn additional points. Users may simultaneously register for the &quot;annual&quot; room, the &quot;three-week&quot; rooms, and the creator rooms."
                            />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph sx={{ mt: 3 }}>
                        <strong>IMPORTANT:</strong> Point accumulation dynamics are governed by the official game rules, 
                        available on the participation website and viewable on the official Fantalab.it website. Players' 
                        scores are assigned based on daily ratings and on-field performance, in accordance with the technical 
                        regulations adopted by the platform. The score and ranking within each room will be determined by the 
                        sum of the points earned by each player on every single matchday, plus any other modifiers provided 
                        for in the rules.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        In the event of a tie in the general ranking, the following tiebreaker criteria will apply, in order:
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Goal difference" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Highest number of goals scored" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Lowest number of goals conceded" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Highest average score" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Random draw via a random selection system" />
                        </ListItem>
                    </List>
                    
                    <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
                        Limits:
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Each user may register for the contest only once." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Only users with a Fantalab Premium account are eligible to win prizes." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph>
                        The Promoter reserves the right, at any time, to verify the validity of entries and participants, 
                        including the participant's identity, age and place of residence, and to disqualify any participant 
                        who breaches these terms and conditions or tampers with the registration process or the Promotion.
                    </Typography>
                </Paper>

                <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                    <Typography variant="h5" component="h3" gutterBottom sx={{ mb: 2 }}>
                        3. Winners' selection
                    </Typography>
                    
                    <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                        PERIODIC RANKINGS
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        At the end of each Block, users who rank in the top positions will be considered winners.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Specifically:</strong>
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        <strong>3-weekly rooms:</strong>
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 1st place winner will be awarded a gaming console — either a PS5 Digital Slim or a Nintendo Switch, subject to availability" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 2nd place winner will be awarded a pair of AirPods 4;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 3rd to 5th place winners will receive a Mystery Box containing a football shirt from one of the top 5 European leagues;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 6th to 10th place winners will receive either a Serie A football or an Amazon voucher worth €50, subject to availability" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 11th to 100th place winners will receive either an Amazon voucher or a Fantalab Premium subscription worth €20, subject to availability." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
                        ANNUAL RANKING
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        At the end of the competition, prizes will be awarded to the participants with the highest total scores 
                        accumulated over the course of the season. The live leaderboard will be available and updated throughout 
                        the season for participants to track their progress.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Specifically:</strong>
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 1st place winner will be awarded a gaming console — either a PS5 Digital Slim or a Nintendo Switch, subject to availability;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 2nd to 10th place winners will receive a pair of AirPods 4;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 11th to 40th place winners will receive a Mystery Box containing a football shirt from one of the top 5 European leagues;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 41st to 100th place winners will receive either a Serie A football or an Amazon voucher worth €50, subject to availability;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 101st to 200th place winners will receive either an Amazon voucher or a Fantalab Premium subscription worth €20, subject to availability." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
                        CREATORS RANKING
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Creator: Carmy Special</strong>
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 1st place winner will be awarded: a ticket to a top match at San Siro with Carmelo Russo, aka Carmyspecial (match ticket + hotel stay), valued at €200,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 2nd place winner will be awarded: a ticket to a home match of Como with Carmelo Russo, aka Carmyspecial (match ticket + hotel stay), valued at €130,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 3rd place winner will be awarded: a ticket to a Zeta Milano match (King's League Italia) with Carmelo Russo, aka Carmyspecial (match ticket + hotel stay), valued at €80,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 4th to 5th place winners will receive a prize valued at €80,00 (Mystery box with football shirts)" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 6th to 7th place winners will receive a prize valued at €50,00 (Serie A football or Amazon voucher subject to availability)" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 8th to 17th place winners will receive a prize valued at €20,00 (Amazon voucher or Fantalab Premium subscription subject to availability)" />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Creator: Il Profeta</strong>
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 1st place winner will be awarded an annual &quot;Cigno Nero&quot; subscription to the YouTube channel Il Profeta, valued at €150,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 2nd to 5th place winners will receive an annual &quot;Underdog&quot; subscription to the YouTube channel Il Profeta, valued at €100,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 6th to 7th place winners will receive a prize valued at €80,00 (Mystery box with football shirts);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 8th to 9th place winners will receive a prize valued at €50,00 (Serie A football or Amazon voucher subject to availability);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 10th to 19th place winners will receive a prize valued at €20,00 (Amazon voucher or Fantalab Premium subscription subject to availability)." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Creator: Luca Diddi</strong>
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 1st and 2nd place winners will be awarded a SICS Match Analyst course, recognized by FIGC, valued at €1.200,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 3rd to 11th place winners will receive participation in an exclusive fantasy football auction with Luca Diddi for the 2026–2027 season, valued at €30,00;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 12th and 13th place winners will receive a prize valued at €80,00 (Mystery box with football shirts);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 14th and 15th place winners will receive a prize valued at €50,00 (Serie A football or Amazon voucher subject to availability);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 16th to 25th place winners will receive a prize valued at €20,00 (Amazon voucher or Fantalab Premium subscription subject to availability)." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Creator: Ludovico Rossini</strong>
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 1st place winner will be awarded exclusive access to the fantasy football beach auction hosted by Ludovico Rossini for the 2026–2027 season, valued at €150;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 2nd and 3rd place winners will receive a prize valued at €80,00 (Mystery box with football shirts);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 4th and 5th place winners will receive a prize valued at €50,00 (Serie A football or Amazon voucher subject to availability);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 6th to 15th place winners will receive a prize valued at €20,00 (Amazon voucher or Fantalab Premium subscription subject to availability)." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Creator: Recosta</strong>
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 1st place winner will receive access to exclusive Recosta videos included in the &quot;ABBONATI A LISTONE&quot; package for the 2026–2027 season, valued at €70,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 2nd place winner will receive fantasy football team-building support from Recosta for the 2026–2027 list-based format, valued at €40,00;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 3rd place winner will receive pre-auction consulting from Recosta for the 2026–2027 season, valued at €20,00;" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 4th and 5th place winners will receive a prize valued at €80,00 (Mystery box with football shirts);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 6th and 7th place winners will receive a prize valued at €50,00 (Serie A football or Amazon voucher subject to availability);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 8th to 17th place winners will receive a prize valued at €20,00 (Amazon voucher or Fantalab Premium subscription subject to availability)." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Creator Lorenzo Cantarini</strong>
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 1st place winner will be awarded a prize valued at €129,99 (LEGO – The Going Merry Pirate Ship);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 2nd place winner will be awarded a prize valued at €49,99 (LEGO – Buggy the Clown's Circus Tent);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 3rd place winner will be awarded a prize valued at €19,99 (LEGO – Monkey D. Luffy + Buggy the Clown);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The 4th and 5th place winners will receive a prize valued at €50,00 (Serie A football or Amazon voucher);" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="From 6th to 15th place winners will receive a prize valued at €20,00 (Amazon voucher or Fantalab Premium subscription, subject to availability)." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph sx={{ mt: 3 }}>
                        For more information on the prizes, please refer to paragraph 4 below.
                    </Typography>
                    
                    <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
                        LIMITS
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Users can register for only one 'creator room'." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="It will not be possible to change the 'creator room' once the competition has started (third match day)." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Users who register after the contest has already started will receive 55 points for each matchday that has already passed." />
                        </ListItem>
                    </List>
                </Paper>

                <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                    <Typography variant="h5" component="h3" gutterBottom sx={{ mb: 2 }}>
                        4. Information on prizes
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        The prizes available are:
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Next-generation console: PS5 Digital Slim with a value of €499,99 or a Nintendo Switch 2 with a value of €509,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="AirPods 4 with a value of €199,99" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Mystery box containing a football shirt from one of the top 5 European leagues: Serie A, Bundesliga, Ligue 1, Premier League, or La Liga, with a value of €80,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Fantalab Premium subscription with a value of €17,99" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Amazon voucher worth €20,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Prize: LEGO – 'The Going Merry Pirate Ship' with a value of €129,99" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Prize: LEGO – 'Buggy the Clown's Circus Tent' with a value of €49,99" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Prize: LEGO – 'Monkey D. Luffy + Buggy the Clown' with a value of €19,98" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Annual 'Cigno Nero' YouTube subscription to the 'Il Profeta' channel, which provides top-tier fantasy football support for the user, with a value of €150,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Annual 'Underdog' YouTube subscription to the 'Il Profeta' channel, which provides fantasy football support for the user, with a value of €100,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Fantasy football auction on the beach in Rimini for the 2026–2027 season, organized by Ludovico Rossini valued 150,00 €" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Match Analyst course by SICS, FIGC-recognized, with a value of €1.200,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Participation in an exclusive fantasy football auction with Luca Diddi, with a value of €30,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Match ticket and overnight stay for a top match at San Siro (Milan or Inter) for the 2026–2027 season with Carmelo Russo, aka Carmyspecial, with a value of €200,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Match ticket and overnight stay for a home match of Como with Carmelo Russo, aka Carmyspecial, with a value of €130,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Match ticket and overnight stay for a Zeta Milano match (King's League Italia) with Carmelo Russo, aka Carmyspecial, with a value of €80,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Annual subscription to Recosta's exclusive videos included in the 'ABBONATI A LISTONE' package, with a value of €70,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Call with Recosta for building a fantasy football team for the list-based format, with a value of €40,00" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Call with Recosta prior to a private auction for the 2026–2027 season, with a value of €20,00." />
                        </ListItem>
                    </List>
                </Paper>

                <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                    <Typography variant="h5" component="h3" gutterBottom sx={{ mb: 2 }}>
                        5. Winners' notification and prize delivery
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        The winners of the periodic rankings and the annual ranking will be notified by email.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        In order to validate their win and receive their prize, winners must reply to the email within 5 
                        calendar days by sending:
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Full residential address" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Telephone number" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Copy of ID card to certify the participant's age" />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph>
                        If no response is received to the notification email within the indicated time, the prize cannot be validated.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        The promoter company and third parties assume no responsibility in the event of non-delivery or late 
                        delivery of the notification email. It is the responsibility of the winner to check that the email 
                        address indicated during the participation phase is correct and valid and that the mailbox is activated 
                        and working.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        <strong>Important:</strong> receipt of the above documentation is a necessary condition for validation 
                        of the prize: otherwise, it cannot be validated. The Promoter reserves the right to carry out the 
                        necessary checks to verify the regularity of the participation as well as the correctness of the data 
                        provided by the participant.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        The Promoter reserves the right to disqualify any participant or winner who has violated any clause 
                        of these terms and conditions.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        All prizes will be delivered within 60 days of winners' confirmation of eligibility.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        It must be noted that:
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The Promoter does not bear liability for any loss caused by incorrect or inaccurate contact details." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The Promoter is entitled choose the delivery method of all prizes at its sole discretion. The Promoter is not responsible for any taxes, customs charges or other costs required for or related to receiving a prize. The Promoter will further not compensate any prize that cannot be redeemed or received by a winner due to customs or other local regulations or that is damaged, delayed or lost by postal, courier or other mail service" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Each winner is required to independently declare and pay any applicable taxes and charges that a prize gives rise to in the winner's jurisdiction." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="No prize is transferable, and no prize may be claimed in cash or changed to another prize or arrangement. However, in the event of unforeseen circumstances or circumstances outside of the Promoter's reasonable control, the Promoter reserves the right to amend, withdraw or substitute a prize for an alternative prize or arrangement." />
                        </ListItem>
                    </List>
                </Paper>

                <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                    <Typography variant="h5" component="h3" gutterBottom sx={{ mb: 2 }}>
                        6. PRIVACY
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        All information provided by a Participant is subject to Promoter's Privacy Policy located at 
                        https://www.Fantalab.it/privacy-policy. In the event of any conflict between these Terms and this 
                        Privacy Policy, these Terms shall control. By entering this Promotion, each entrant agrees that the 
                        Promoter, its agents and/or representatives may store, share and use the personal information he/she 
                        submitted for the purpose of administering the Promotion and agrees to the collection, use and 
                        disclosure of his/her personal information as described in these Terms, in the above Privacy Policy 
                        and as permitted by law.
                    </Typography>
                </Paper>

                <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                    <Typography variant="h5" component="h3" gutterBottom sx={{ mb: 2 }}>
                        7. GENERAL
                    </Typography>
                    
                    <List sx={{ pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Information on how to enter forms part of these conditions. By participating, you agree to be bound by these conditions" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="Entry into this Promotion constitutes consent by the winners for the Promoter to use their names for publicity purposes. Winners agree to take part in reasonable publicity required by the Promoter." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The Promoter cannot accept any responsibility for any damage, loss, injury (including indirect or consequential loss) suffered by any entrant entering the Promotion or as a result of accepting any prize. However, nothing shall exclude the Promoter's liability for death or personal injury as a result of its negligence." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The Promoter is not responsible for any technical problems or human error that may result in a registration, submission or entry not being received or being lost or damaged or for any destruction or alteration thereof, or unauthorized access to the website." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The Promoter's decisions regarding any aspect of this Promotion is final and no correspondence will be entered into. The Promoter may refuse to award a prize to any person, for any reason." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The Promoter reserves the right to withdraw, vary, cancel or suspend an element of a prize if, due to circumstances outside of its control, that element is no longer available. The Promoter will not be responsible for, or liable to any winner, if all or part of a prize is not available or must be varied or cancelled for any reason. In the event of unforeseen circumstances, the Promoter reserves the right to substitute a prize or an element of the prize for an alternative of equal or greater value." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The Promoter is not responsible for any third-party acts." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="This Promotion is subject to all applicable laws and regulations." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="If an act, omission, event or circumstance occurs which us beyond the reasonable control of the Promoter and which prevents the Promoter from complying with these terms and conditions the Promoter will not be liable for any failure to perform or delay in performing its obligation." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="If this Promotion is interfered with in any way or is not capable of being conducted as reasonably anticipated due to any reason beyond the reasonable control of the Promoter including because of war, terrorism, state of emergency or disaster (including natural disaster), infection by computer virus, bugs, tampering, unauthorized intervention, technical failures or any which corrupt or affect the administration, security, fairness, integrity or proper conduct of this Promotion, the Promoter reserves the right, in its sole discretion, to the fullest extent permitted by law (a) to disqualify any entrant; or (b) subject to any written directions from a regulatory authority, to modify, suspend, terminate or cancel this Promotion, as appropriate." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The Promoter reserves the right to verify the validity of entries and reserves the right to disqualify any entrant for tampering with the entry process or for submitting an entry which is not in accordance with these conditions of entry, or if the entrant is engaged in any unlawful or other improper misconduct calculated to jeopardize the fair and proper conduct of the Promotion. The Promoter's legal rights to recover damages or other compensation from such an offender are reserved." />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            <ListItemText primary="The winners' list will be made available on https://app.Fantalab.it/signup." />
                        </ListItem>
                    </List>
                    
                    <Typography variant="body1" paragraph sx={{ mt: 3 }}>
                        These Terms and Conditions are available at https://www.Fantalab.it/ in the section related to this promotion.
                    </Typography>
                    
                    <Typography variant="body1" paragraph>
                        This promotion shall be governed by UK law.
                    </Typography>
                </Paper>
            </Container>
        </MainLayout>
    )
}
export default FantalabManagerRulesPage
